export const EVENTS_TABLE_COLUMNS = ['Status', 'Location', 'Date', 'Vessel', 'Remarks'];
